import { appendIf } from '@btime/helpers'
import { assoc, compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { generalClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertMask($input: MaskInput) {
    upsertMask(input: $input) {
      id
    }
  }
`

const cleanRequest = compose(pick(['id', 'name', 'pattern']))

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' }),
    ...appendIf(!form.pattern, { path: ['pattern'], message: 'Campo obrigatório' })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveMask = () => {
  const closeModal = useCloseModal()

  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Masks', `Mask`, 'MaskCount'],
    client: generalClient
  })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
